import { render, staticRenderFns } from "./UserWidget.vue?vue&type=template&id=04afdb8a"
import script from "./UserWidget.vue?vue&type=script&lang=js"
export * from "./UserWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports